import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FolderFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6C5.67157 6 5 6.67157 5 7.5V9.99982C5.41783 9.68597 5.9372 9.5 6.5 9.5H17.5C18.0628 9.5 18.5822 9.68597 19 9.99982V9.5C19 8.67157 18.3284 8 17.5 8H12.654C12.2567 8 11.8971 7.76481 11.7379 7.40082L11.3871 6.59918C11.2279 6.23519 10.8683 6 10.471 6H6.5ZM19 13V12C19 11.1716 18.3284 10.5 17.5 10.5H6.5C5.67157 10.5 5 11.1716 5 12V13V16.5C5 17.3284 5.67157 18 6.5 18H17.5C18.3284 18 19 17.3284 19 16.5V13Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { FolderFilledIcon };
